<template>
	<v-container>
		<v-card class="mx-auto" max-width="500">
			<v-card-title>Ρυθμίσεις εταιρίας</v-card-title>
			<v-card-text>
				<v-window v-model="step">
					<v-window-item v-bind:value="0">
						<h3 class="text-h6 font-weight-light mb-2">Βασικά στοιχεία</h3>
						<v-text-field label="Επωνυμία" v-model="company.name"></v-text-field>
						<v-text-field label="ΑΦΜ" v-model="company.tax_registration_number"></v-text-field>
						<v-select label="ΔΟΥ" v-bind:items="taxOffices" v-model="company.tax_registration_office_id" item-text="name" item-value="id"></v-select>
						<v-text-field label="Έδρα" v-model="company.location"></v-text-field>
						<v-text-field label="Διεύθυνση" v-model="company.address"></v-text-field>
						<v-text-field label="Ταχ. Κωδικός" v-model="company.zipcode"></v-text-field>
						<v-text-field label="Τηλέφωνο" v-model="company.telephone"></v-text-field>
						<v-text-field label="Φαξ" v-model="company.fax"></v-text-field>
						<v-text-field label="Αρ. ΓΕΜΗ" v-model="company.trade_registry_number"></v-text-field>
					</v-window-item>
					<v-window-item v-bind:value="1">
						<h3 class="text-h6 font-weight-light mb-2">Στοιχεία ΑΑΔΕ</h3>
						
						<v-text-field label="Όνομα χρήστη μητρώου ΑΦΜ" v-model="company.tax_authority_registry_username"></v-text-field>
						<v-text-field label="Κωδικός μητρώου ΑΦΜ" v-model="company.tax_authority_registry_password"></v-text-field>
						
						<v-text-field label="Όνομα χρήστη myData" v-model="company.tax_authority_mydata_username"></v-text-field>
						<v-text-field label="Subscription Key myData" v-model="company.tax_authority_mydata_subscription_key"></v-text-field>

						<v-checkbox label="Ενημέρωση myData κατά την έκδοση" v-model="company.tax_authority_mydata_auto_upload"></v-checkbox>
					</v-window-item>

					<v-window-item v-bind:value="2">
						<h3 class="text-h6 font-weight-light mb-2">Στοιχεία email</h3>
						
						<v-text-field label="hostname" v-model="company.smtp_hostname"></v-text-field>
						<v-text-field label="port" type="number" v-model.number="company.smtp_port"></v-text-field>
						<v-text-field label="username" v-model="company.smtp_username"></v-text-field>
						<v-text-field label="password" v-model="company.smtp_password"></v-text-field>
						<v-text-field label="mailbox" v-model="company.smtp_mailbox"></v-text-field>
						
					</v-window-item>


					<v-window-item v-bind:value="3">
						<h3 class="text-h6 font-weight-light mb-2">Λοιπά στοιχεία email</h3>
						
						<file-uploader title="Λογότυπο παραστατικών"></file-uploader>
												

						<div class="text-center">
							<v-btn class="mb-4 mt-4" color="success" v-bind:loading="saveButtonDisabled" @click="save">ΑΠΟΘΗΚΕΥΣΗ</v-btn>
						</div>
					</v-window-item>

				</v-window>
			</v-card-text>
			<v-card-actions>
                <v-btn
					v-bind:disabled="step <= 0"
    	              text
        	          v-on:click="step--"
            	      color="primary">
                	  ΠΙΣΩ
                </v-btn>
                <v-spacer></v-spacer>
                
				<v-item-group
					v-model="step"
                  	class="text-center"
                  	mandatory>
                  	<v-item
						v-for="n in totalSteps"
						:key="`btn-${n}`"
						v-slot="{ active, toggle }">
				
						<v-btn v-bind:input-value="active" icon @click="toggle">
							<v-icon>mdi-record</v-icon>
						</v-btn>
					</v-item>
				</v-item-group>
                
                <v-spacer></v-spacer>
                <v-btn
                  	v-bind:disabled="step >= totalSteps - 1"
                  	color="primary"
                  	depressed
                  	@click="step++">
					ΕΠΟΜΕΝΟ
                </v-btn>
			</v-card-actions>
		</v-card>		
	</v-container>
</template>


<script>
import LoginForm from '../LoginForm.vue';
export default {
  	components: { LoginForm },
	data: () => ({
	
    	step: 0,
		totalSteps: 4,
		taxOffices: [],
		company: {},
		saveButtonDisabled: false
	}),

	created() {
		this.initialize()
	},

	methods: {
		initialize() {
			axios.get("/api/company")
			.then(response => this.company = response.data)
			// .catch(error => console.log(error))

			axios.get("/api/tax-offices")
			.then(response => this.taxOffices = response.data)
			// .catch(error => console.log(error))
		},

		save() {
			this.saveButtonDisabled = true;

			let requestBody = {
				name: this.company.name,
				tax_registration_number: this.company.tax_registration_number,
				tax_registration_office_id: this.company.tax_registration_office_id,
				location: this.company.location,
				address: this.company.address,
				zipcode: this.company.zipcode,
				telephone: this.company.telephone,
				fax: this.company.fax,

				smtp_hostname: this.company.smtp_hostname,
				smtp_port: this.company.smtp_port,
				smtp_username: this.company.smtp_username,
				smtp_password: this.company.smtp_password,
				smtp_mailbox: this.company.smtp_mailbox,
				smtp_encryption: this.company.smtp_encryption,

				tax_authority_registry_username: this.company.tax_authority_registry_username,
				tax_authority_registry_password: this.company.tax_authority_registry_password,

				tax_authority_mydata_auto_upload: this.company.tax_authority_mydata_auto_upload,

				tax_authority_mydata_username: this.company.tax_authority_mydata_username,
				tax_authority_mydata_subscription_key: this.company.tax_authority_mydata_subscription_key,

				trade_registry_number: this.company.trade_registry_number
			}

			console.log(requestBody);

			axios.patch('/api/company', requestBody )
			.then(response => { this.company = response.data })
			.catch(error => { console.log(error); this.allerrors = error.response.data.errors } )
			.finally(() => { this.saveButtonDisabled = false; })
		}
	}	

};
</script>

<style scoped>
</style>